import React, { useState } from 'react';
import styled from 'styled-components';
import MenuItem from '@mui/material/MenuItem';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import Popover, { PopoverOrigin } from '@mui/material/Popover';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd } from '@fortawesome/pro-light-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const StyledMenu = styled.div`
  color: ${COLORS.ctaPrimary};
  .menu-item {
    min-width: 140px;
    padding-top: ${SPACERS.small};
    padding-bottom: ${SPACERS.small};
  }
`;

const anchorOrigin: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};
const transformOrigin: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'center',
};

export interface AddNewButtonProps {
  addButtonText?: string;
  onAdd:
    | (() => unknown)
    | {
        text: string;
        onClick: () => unknown;
      }[];
}

const AddNewButton: React.FC<AddNewButtonProps> = ({
  onAdd,
  addButtonText = 'Add New',
}) => {
  const [open, setOpen] = useState<HTMLButtonElement | undefined>(undefined);
  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(e.currentTarget);
  };
  const handleClose = () => {
    setOpen(undefined);
  };

  if (typeof onAdd !== 'function' && onAdd.length === 0) {
    return null;
  }

  return (
    <div>
      <TrueImpactButton
        className="add-new-button"
        onClick={typeof onAdd === 'function' ? onAdd : handleOpen}
      >
        {addButtonText}
        <FontAwesomeIcon icon={faAdd} className="add-new-button-icon" />
      </TrueImpactButton>
      {typeof onAdd !== 'function' && (
        <Popover
          open={Boolean(open)}
          anchorEl={open}
          onClose={handleClose}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
        >
          <StyledMenu>
            {onAdd.map(add => (
              <MenuItem
                key={add.text}
                onClick={() => {
                  add.onClick();
                  handleClose();
                }}
                className="menu-item"
              >
                {add.text}
              </MenuItem>
            ))}
          </StyledMenu>
        </Popover>
      )}
    </div>
  );
};

export default AddNewButton;
